import { S } from './estado.js';
import { dias, fecha, normaliza } from './formato.js';
import { db } from '../data/db.js';

export const precioDe      = id => db.precios.find(p=>p.id===id);
export const contratoDe    = id => db.contratos.find(c=>c.id===id);
export const usuarioDe     = id => db.usuarios.find(u=>u.id===id);
export const pedidoDe      = id => db.pedidos.find(p=>p.id===id);
// El precio se congela en la imputación al registrarla (precioUnitario): si
// luego cambia el precio de la unidad, esta no se recalcula. precioDe(...)
// solo es respaldo para filas que aún no lo traigan.
export const importeDe     = i => i.cantidad * (i.precioUnitario ?? precioDe(i.precio)?.precio ?? 0);
export const totalPedido   = p => p.lineas.reduce((s,l)=>s+l.cantidad*precioDe(l.precio).precio, 0);
export const servidoPedido = p => p.lineas.reduce((s,l)=>s+l.servida*precioDe(l.precio).precio, 0);

export function contratosVisibles(soloActivos=false){
  let cs = db.contratos.filter(c=>!soloActivos || c.estado==='activo');
  if(S.usuario.contratos!=='todos') cs = cs.filter(c=>S.usuario.contratos.includes(c.id));
  return cs;
}

export function balance(cid){
  const c = contratoDe(cid);
  const imps = db.imputaciones.filter(i=>i.contrato===cid);
  const certificado = imps.filter(i=>i.estado==='certificada').reduce((s,i)=>s+importeDe(i),0);
  const validado    = imps.filter(i=>i.estado==='validada').reduce((s,i)=>s+importeDe(i),0);
  const borrador    = imps.filter(i=>i.estado==='borrador').reduce((s,i)=>s+importeDe(i),0);
  const comprometido = db.pedidos.filter(p=>p.contrato===cid && ['solicitado','confirmado','parcial'].includes(p.estado))
                        .reduce((s,p)=>s + (totalPedido(p)-servidoPedido(p)), 0);
  const consumido = certificado + validado + borrador;
  return {contrato:c, imputaciones:imps, certificado, validado, borrador, consumido, comprometido,
          saldo:c.adjudicado-consumido, saldoReal:c.adjudicado-consumido-comprometido,
          pct: c.adjudicado ? consumido/c.adjudicado*100 : 0,
          pctCert: c.adjudicado ? certificado/c.adjudicado*100 : 0,
          diasRestantes: dias(c.fin)};
}

export function balanceAnual(cid, anio){
  const c = contratoDe(cid);
  const a = (c.anualidades||[]).find(x=>x.anio===anio);
  const tope = a ? a.importe : 0;
  const gasto = db.imputaciones.filter(i=>i.contrato===cid && +i.fecha.slice(0,4)===anio).reduce((s,i)=>s+importeDe(i),0);
  return {anio, tope, gasto, saldo:tope-gasto, pct: tope ? gasto/tope*100 : 0};
}

export const nivel = pct => pct>=95 ? 'exceso' : pct>=78 ? 'alerta' : 'ok';

/* Busca por todas las palabras escritas (sin distinguir mayúsculas ni
   acentos), en código y descripción a la vez. Máximo 8 resultados.
   Los precios llegan ordenados por código como texto ("1","10","100"...),
   así que con una palabra suelta que da muchas coincidencias (p.ej.
   "triangular") coger las 8 primeras de ese orden dejaba fuera unidades
   tan válidas como las demás sin ningún criterio real. Se ordenan por
   relevancia antes de recortar: coincidencia exacta del código primero,
   y si no, la descripción más corta (más concreta, con menos ruido). */
export function filtrarPrecios(precios, query){
  const palabras = normaliza(query).trim().split(/\s+/).filter(Boolean);
  if(!palabras.length) return [];
  const qNorm = normaliza(query).trim();
  return precios.filter(p=>{
    const t = normaliza(`${p.codigo} ${p.desc}`);
    return palabras.every(w=>t.includes(w));
  }).sort((a,b)=>{
    const exactoA = normaliza(a.codigo)===qNorm, exactoB = normaliza(b.codigo)===qNorm;
    if(exactoA!==exactoB) return exactoA ? -1 : 1;
    return a.desc.length-b.desc.length;
  }).slice(0,8);
}
